export const PAGE_LABELS = {
  "/": "Home", "/chi-siamo": "Chi siamo", "/certificazioni": "Certificazioni",
  "/bim": "Progettazione BIM", "/lavori": "I nostri lavori", "/contatti": "Contatti",
  "/preventivo": "Formula un preventivo", "/lavora-con-noi": "Lavora con noi",
  "/privacy": "Privacy", "/cookie": "Cookie",
};

export const romeToday = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(new Date());
export const daysBefore = (day, count) => {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() - count);
  return date.toISOString().slice(0, 10);
};